"use client";

import { InputHTMLAttributes } from "react";
import { cva, VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";

export interface InputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
  label?: string;
  numeric?: boolean;
  decimalScale?: number;
  allowNegative?: boolean;
  showMessage?: boolean;
}

const inputVariants = cva("", {
  variants: {
    variant: {
      default:
        "block w-full rounded-lg h-10 py-2 text-sm border-zinc-200 border focus:border-zinc-400 placeholder:text-zinc-600",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const FormInput = ({
  label,
  variant,
  className,
  type,
  numeric,
  showMessage = true,
  decimalScale = 2,
  allowNegative = true,
  ...props
}: InputProps) => {
  return (
    <div>
      {label && (
        <div className="text-sm font-medium text-zinc-800 mb-1 block">
          {label}
        </div>
      )}
      <div className="relative flex items-center">
        <Input
          className={cn(
            inputVariants({
              variant,
            }),
            className
          )}
          numeric={numeric}
          id={props.id}
          type={type}
          placeholder={props.placeholder}
          {...props}
          decimalScale={decimalScale}
          allowNegative={allowNegative}
        />
      </div>
    </div>
  );
};

FormInput.displayName = "FormInput";

export { FormInput };
